<template>
  <div class="flex flex-row border-b-4 border-green">
    <app-year-selector color="green">
      <template v-slot:icon>
        <receipt-icn
          :class="['ml-3 mr-3 green-icon']"
          width="20px"
          height="20px"
          fill-rule="evenodd"
        ></receipt-icn>
      </template>
    </app-year-selector>

    <app-search-input-click
      class="top-1"
      color="green"
      :class="isInput ? '' : 'hidden'"
    ></app-search-input-click>
    <app-download-searche
      class="top-0.5 my-0"
      color="green"
      :class="isSelect ? '' : 'hidden'"
    ></app-download-searche>
    <app-search-input-select
      class="top-1 mr-auto"
      color="green"
      :class="isInput || isSelect ? 'hidden' : ''"
    ></app-search-input-select>
    <div
      :class="isInput || isSelect ? '' : 'hidden'"
      style="margin: 10px auto 10px 10px;"
      @click="clearSearch"
    >
      <close-icn
        class="m-auto green-icon"
        width="20px"
        height="20px"
        fill-rule="evenodd"
      ></close-icn>
    </div>
    <app-select-filter class="top-1" color="green" style="width:165px;">
      <template v-slot:filterBtnContent>
        <div
          class="flex items-center"
          v-show="JSON.stringify(filteredStatus) == JSON.stringify([])"
        >
          <span class="text-green text-lg font-bold span-after">すべて</span>
        </div>
        <div
          class="flex items-center"
          v-show="JSON.stringify(filteredStatus) == JSON.stringify([1])"
        >
          <EditIcn width="20px" height="20px" class="mr-1" />
          <span class="text-green text-lg font-bold span-after">作成中</span>
        </div>
        <div
          class="flex items-center"
          v-show="JSON.stringify(filteredStatus) == JSON.stringify([2, 6])"
        >
          <ApprovedYellowIcn width="20px" height="20px" class="mr-1" />
          <span class="text-green text-lg font-bold span-after">確認待</span>
        </div>
        <div
          class="flex items-center"
          v-show="JSON.stringify(filteredStatus) == JSON.stringify([3, 7])"
        >
          <RejectedIcn width="20px" height="20px" class="mr-1" />
          <span class="text-green text-lg font-bold span-after">再確認</span>
        </div>
        <div
          class="flex items-center"
          v-show="JSON.stringify(filteredStatus) == JSON.stringify([4, 5])"
        >
          <ApprovedGreenIcn width="20px" height="20px" class="mr-1" />
          <span class="text-green text-lg font-bold span-after">確認済</span>
        </div>

        <div
          class="flex items-center"
          v-show="JSON.stringify(filteredStatus) == JSON.stringify([1, 2, 3])"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mr-1"
          >
            <circle cx="8" cy="8" r="7.5" fill="#549A1D" stroke="white" />
            <path
              d="M10.8 3.15026C10.1304 2.76366 9.27413 2.99309 8.88753 3.6627L5.73753 9.11866L8.1624 10.5187L11.3124 5.0627C11.699 4.39309 11.4696 3.53686 10.8 3.15026Z"
              fill="white"
            />
            <path
              d="M5.5376 12.9149C5.28931 13.1103 4.92969 12.9026 4.97474 12.5899L5.38753 9.7249L7.8124 11.1249L5.5376 12.9149Z"
              fill="white"
            />
            <circle cx="14" cy="14" r="7" fill="#E81919" />
            <path
              d="M14 8.40021C13.0743 8.40021 12.3614 9.21697 12.4864 10.1342L13.2054 15.4066C13.2596 15.804 13.599 16.1002 14 16.1002C14.401 16.1002 14.7404 15.804 14.7946 15.4066L15.5135 10.1342C15.6386 9.21697 14.9257 8.40021 14 8.40021Z"
              fill="white"
            />
            <path
              d="M14 19.6002C14.7732 19.6002 15.4 18.9734 15.4 18.2002C15.4 17.427 14.7732 16.8002 14 16.8002C13.2268 16.8002 12.6 17.427 12.6 18.2002C12.6 18.9734 13.2268 19.6002 14 19.6002Z"
              fill="white"
            />
          </svg>
          <span class="text-green text-lg font-bold span-after">未処理</span>
        </div>
      </template>

      <template v-slot:filterContent>
        <button
          class="filter-btn"
          style="width: 120px;"
          @click="setFilteredStatus([])"
        >
          <span class="mx-auto span-after">すべて</span>
        </button>
        <button class="filter-btn" @click="setFilteredStatus([1])">
          <EditIcn width="20px" height="20px" class="mr-1" />
          <span class="span-after">作成中</span>
        </button>
        <button class="filter-btn" @click="setFilteredStatus([2, 6])">
          <ApprovedYellowIcn width="20px" height="20px" class="mr-1" />
          <span class="span-after">確認待</span>
        </button>
        <button class="filter-btn" @click="setFilteredStatus([3, 7])">
          <RejectedIcn width="20px" height="20px" class="mr-1" />
          <span class="span-after">再確認</span>
        </button>
        <button class="filter-btn" @click="setFilteredStatus([4, 5])">
          <ApprovedGreenIcn width="20px" height="20px" class="mr-1" />
          <span class="span-after">確認済</span>
        </button>
        <hr />
        <button class="filter-btn" @click="setFilteredStatus([1, 2, 3])">
          <svg
            width="20"
            height="20"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mr-1"
          >
            <circle cx="8" cy="8" r="7.5" fill="#549A1D" stroke="white" />
            <path
              d="M10.8 3.15026C10.1304 2.76366 9.27413 2.99309 8.88753 3.6627L5.73753 9.11866L8.1624 10.5187L11.3124 5.0627C11.699 4.39309 11.4696 3.53686 10.8 3.15026Z"
              fill="white"
            />
            <path
              d="M5.5376 12.9149C5.28931 13.1103 4.92969 12.9026 4.97474 12.5899L5.38753 9.7249L7.8124 11.1249L5.5376 12.9149Z"
              fill="white"
            />
            <circle cx="14" cy="14" r="7" fill="#E81919" />
            <path
              d="M14 8.40021C13.0743 8.40021 12.3614 9.21697 12.4864 10.1342L13.2054 15.4066C13.2596 15.804 13.599 16.1002 14 16.1002C14.401 16.1002 14.7404 15.804 14.7946 15.4066L15.5135 10.1342C15.6386 9.21697 14.9257 8.40021 14 8.40021Z"
              fill="white"
            />
            <path
              d="M14 19.6002C14.7732 19.6002 15.4 18.9734 15.4 18.2002C15.4 17.427 14.7732 16.8002 14 16.8002C13.2268 16.8002 12.6 17.427 12.6 18.2002C12.6 18.9734 13.2268 19.6002 14 19.6002Z"
              fill="white"
            />
          </svg>

          <span class="span-after">未処理</span>
        </button>
      </template>
    </app-select-filter>

    <button style="padding: 10px 10px" @click="reverseSort()">
      <ArrowIcn
        width="20px"
        height="20px"
        class="green-icon transform rotate-90"
        :class="isReversedSort ? 'transform -rotate-90' : ''"
      />
    </button>
  </div>
</template>

<script>
import AppYearSelector from '@/components/ui/AppYearSelector'
import AppSearchInputClick from '@/components/ui/AppSearchInputClick'
import AppSelectFilter from '@/components/ui/AppSelectFilter'
import ArrowIcn from '@/assets/icons/arrow.svg?inline'
import ReceiptIcn from '@/assets/icons/receipt.svg?inline'
import { useReceipts } from '@/services/receipt/useReceipts'
import EditIcn from '@/assets/icons/edit-green-circle.svg?inline'
import ApprovedYellowIcn from '@/assets/icons/approved-yellow.svg?inline'
import ApprovedGreenIcn from '@/assets/icons/approved-green.svg?inline'
import RejectedIcn from '@/assets/icons/rejected.svg?inline'
import CloseIcn from '@/assets/icons/close.svg?inline'
import AppSearchInputSelect from '@/components/ui/AppSearchInputSelect'
import AppDownloadSearche from '@/components/ui/AppDownloadSearche'
import { useInputSelectSearch } from '@/services/useInputSelectSearch'
import { useKeywordSearch } from '@/services/useKeywordSearch'
import { useDenominationSelect } from '@/services/useDenominationSelect'

export default {
  name: 'ReceiptsTableHeader',

  components: {
    AppYearSelector,
    AppSearchInputClick,
    AppSelectFilter,
    ReceiptIcn,
    ArrowIcn,
    EditIcn,
    ApprovedYellowIcn,
    ApprovedGreenIcn,
    RejectedIcn,
    CloseIcn,
    AppSearchInputSelect,
    AppDownloadSearche,
  },

  setup() {
    const { filteredStatus, isReversedSort } = useReceipts()
    const { isInput, isSelect } = useInputSelectSearch()
    const { clearInput } = useKeywordSearch()
    const { clearSelect } = useDenominationSelect()

    const setFilteredStatus = status => {
      filteredStatus.value = [...status]
    }

    const reverseSort = () => {
      isReversedSort.value = !isReversedSort.value
    }

    const clearSearch = () => {
      isInput.value = false
      isSelect.value = false
      clearInput()
      clearSelect()
    }

    return {
      filteredStatus,
      setFilteredStatus,
      reverseSort,
      isReversedSort,
      isInput,
      isSelect,
      clearSearch,
    }
  },
}
</script>

<style lang="scss" scoped>
.filter-btn {
  height: 40px;
  font-family: Noto Sans JP;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  color: theme('colors.green.DEFAULT');
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-start;
  align-items: center;
}
span.span-after {
  &::after {
    content: 'を表示';
    font-size: 14px;
    line-height: 20px;
  }
}

hr {
  border-style: dotted;
  border-color: theme('colors.green.DEFAULT');
}
</style>
